module.exports = __webpack_public_path__ + "img/box-svgrepo-com.8ec41f80.svg";